import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { PPToProductInstructionDispatcher, PPToProductInstructionStore } from "../Store/Variable";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionProcessClient } from "../../../../../../Wrap/Api/Instruction/InstructionProcess";
import { BuyAction } from "../../Buy/Action/BuyAction";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ClientTradableInvestments } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSearchQuery } from "../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { AssetsToSellFromPP } from "../Store/PPToProductInstructionStatic";
import { InvestmentSelectionAction } from "../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { Instrument } from "../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { ProductAllocation } from "../../../../../../Wrap/Models/Domains/Transfer/Gia/ProductAllocation";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";

export class PPToProductAction {
    public static getInstruction(id, type, hierarchyId, subAccountHierarchyId, clientId, processType, action): void {
        const giaContributionInstruction = new GiaContributionInstructionClient();
        this.getOrCreateInstruction(
            giaContributionInstruction,
            id,
            hierarchyId,
            subAccountHierarchyId,
            clientId,
            processType,
            action,
        );
    }

    public static saveInstruction(from, data: GiaContributionModel, callback?: (data) => void): void {
        const giaContributionInstruction = new GiaContributionInstructionClient();
        let promise = giaContributionInstruction.put(data, "");
        this.updatePPToProductInstructionStore(promise, callback);
    }
    public static submitInstruction(id, data, customerId, claccountId, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) callback();
        });
    }
    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) callback();
        });
    }
    private static getOrCreateInstruction(
        client: GiaContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId,
        processType,
        action?,
    ) {
        if (id && id !== "") {
            // Have instructionId
            const promise = client.get(id, clientId, action, null);
            this.updatePPToProductInstructionStore(promise);
        } else {
            // Create new instruction
            //PpToIsaFeedTool
            const promise = client.post(subAccountHierarchyId, hierarchyId, processType);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const batchId = getQueryParameters()["batchid"];
                const model = client.get(instructionId, clientId, action, batchId);
                this.updatePPToProductInstructionStore(model);
            });

            promise.onError((err) => {
                PPToProductInstructionDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    public static postInstructionProcess(instructionId: number, processType: ActivityType) {
        const client = new InstructionProcessClient();
        const promise = client.post(instructionId, processType);
    }

    private static updatePPToProductInstructionStore(promise: any, callback?: (data: GiaContributionModel) => void) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(PPToProductInstructionStore.getData()));
            if (!data) data = {};
            data = result;
            PPToProductInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors);
            } else {
                callback(data);
            }
        });

        promise.onError((err) => {
            PPToProductInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getSellableAssets = (type: SubAccountType, hierarchyid, subAccountHierarchyId, callback?) => {
        BuyAction.getReuseHoldingsExcludeAdj(hierarchyid, subAccountHierarchyId, 0, (data: ClientTradableInvestments) => {
            const inidividual = data.CurrentIndividualHoldings.filter(
                (ele) =>
                    (ele.CurrQuantity > 0 && !ele.HasOpenValueSellOrder && ele.MarketValue?.Amount > 0) ||
                    ele.Type == ProductType.Cash
            );
            const model = data.CurrentModelHoldings.filter(
                (ele) => ele.CurrQuantity > 0 && !ele.HasOpenValueSellOrder && ele.MarketValue?.Amount > 0
            );
            let ids =[];

            let holdingIds = inidividual.map((ele) => ele.ProductId);
            holdingIds = holdingIds.concat(model.map((ele) => ele.ProductId));
            
            let targetAllocationsIds = data.TargetAllocations?.map((ele) => ele.ProductId);
            ids = holdingIds.concat(targetAllocationsIds);

            const query: InstrumentSearchQuery = {
                ProductWrapperTypes: [type],
                ProductIds: ids,
                CanBeSold: true,
                ResultsPerPage: ids.length,
                ServiceProposition: data.AccountServiceProposition,
            };
            let currentAssets: AssetsToSellFromPP[] = [];
            let targetAllocations: AssetsToSellFromPP[] = [];
            if (ids.length > 0) {
                InvestmentSelectionAction.searchInstruments(query, subAccountHierarchyId, (result: Instrument[]) => {
                    result.forEach((ele) => {
                        const obj = data.CurrentIndividualHoldings.find((item) => item.ProductId == ele.ProductId);
                        const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);
                        const targetAllocation = data.TargetAllocations.find((item) => item.ProductId == ele.ProductId);
                        if (obj) {
                            currentAssets.push({
                                ProductId: obj.ProductId,
                                ProductCode: obj.InstrumentCode,
                                AssetName: obj.DisplayName,
                                MarketValue: obj.MarketValue,
                                ProductType: obj.Type,
                                DisinvestAll: false,
                                FactsheetUrl: obj.FinexFactSheetUrl,
                                IsDeferred: ele?.IsDeferred,
                            });

                        } else if (model) {
                            currentAssets.push({
                                ProductId: model.ProductId,
                                ProductCode: model.InstrumentCode,
                                AssetName: model.DisplayName,
                                MarketValue: model.MarketValue,
                                ProductType: model.Type,
                                DisinvestAll: false,
                                FactsheetUrl: model.FinexFactSheetUrl,
                                IsDeferred: ele?.IsDeferred,
                            });
                            targetAllocations.push({
                                ProductId: model.ProductId,
                                ProductCode: model.InstrumentCode,
                                AssetName: model.DisplayName,
                                MarketValue: model.MarketValue,
                                ProductType: model.Type,
                                DisinvestAll: false,
                                FactsheetUrl: model.FinexFactSheetUrl,
                                IsDeferred: ele?.IsDeferred,
                            });
                        }

                        if(targetAllocation)
                        {
                            targetAllocations.push({
                                ProductId: ele.ProductId,
                                ProductCode: ele.ProductCode,
                                AssetName: ele.Name,
                                ProductType: ele.Type,
                                DisinvestAll: false,
                                FactsheetUrl: targetAllocation.FinexFactSheetUrl,
                                IsDeferred: ele?.IsDeferred,
                                Weighting:targetAllocation.Weighting
                            });
                        }
                    });
                    if (callback) callback({
                        currentAssets:currentAssets,
                        targetAllocations:targetAllocations
                    });
                });
            }
            else
            {
                if (callback) callback({
                    currentAssets:currentAssets,
                    targetAllocations:targetAllocations
                });
            }
        });
    };

    public static getAllocationAssetDetails(buyAllocations: ProductAllocation[], sellAllocations: ProductAllocation[], callback?) {
        const productIds = [];
        const hierarchyId = getQueryParameters()["hierarchyid"];
        if (buyAllocations && buyAllocations.length > 0) {
            buyAllocations.map(item => { productIds.push(item.ProductId) });
        }
        if (sellAllocations && sellAllocations.length > 0) {
            sellAllocations.map(item => { productIds.push(item.ProductId) });
        }
        if (productIds.length > 0) {
            this.getAssetDetails(productIds, hierarchyId, (result) => {
                if(callback) callback(result,buyAllocations,sellAllocations);
            })
        }
    }

    public static getAssetDetails = (productIds, hierarchyid, callback?) => {
        const query: InstrumentSearchQuery = {
            ProductIds: productIds,
        };
        InvestmentSelectionAction.searchInstruments(query, hierarchyid, (result: Instrument[]) => {
            if (callback) callback(result);
        });
    };
    
    // public static cancelBankAccountInstruction(
    //     bankAccountInstruction: BankAccountInstruction,
    //     callBack?: (val: BankAccountInstruction) => void
    // ): void {
    //     const client = new BankAccountInstructionClient();
    //     const promise = client.delete(bankAccountInstruction);
    //     promise.onSuccess((result) => {
    //         if (callBack) {
    //             callBack(result);
    //         }
    //     });
    //     promise.onError((err) => {});
    // }
    // public static checkRegularPaymentAutolineCompleted(
    //     regularBuyId: number,
    //     callBack?: (result: RegularPaymentResult) => void
    // ): void {
    //     const client = new CheckRegularPaymentAutolineCompletedClient();
    //     const promise = client.get(regularBuyId);
    //     promise.onSuccess((result) => {
    //         if (callBack) {
    //             callBack(result);
    //         }
    //     });
    //     promise.onError((err) => {});
    // }
}
